<template>
  <div class="rx-app-container">
    <HanderNav title="匹配成功"></HanderNav>
    <MideelApply :is-open="loading" @end="onEnd"></MideelApply>
    <template v-if="shosP">
      <div class="main-content">
        <div class="subtitle">根据您的资质情况！</div>
        <div class="desc">
          已为您精选以下产品，<span class="desc-highlight">仅限今日有效!</span>
        </div>
        <div class="risk-tip-container">
          <div class="title">
            <i></i>请勿接听任何<span class="ctip">境外来电!</span>
          </div>
          <div class="tip-msg">
            任何放款前以缴纳保证金、利息等名义的行为均为
            <span class="ctip">诈骗!</span> 任何要求您提供银行卡
            密码、验证码等个人信息均为 <span class="ctip">诈骗!</span>
            <i></i>
          </div>
        </div>

        <ProductCard v-for="p in productList" :key="p.id" :isApply="false" :product="p" @select="selectProduct" />
        <div class="select-tip">
          一键全选 <span class="select-tip-sub">(勾选越多，下款成功率越高)</span>
          <i class="selete " :class="{ 'active': isAllSelete }" @click="onAllSeleteProduct"></i>
        </div>
        <van-button :loading="submitLoading" :disabled="isDisabled" loading-type="spinner" loading-text="立即借款"
          class="apply-btn" @click="submit">立即借款</van-button>
        <AgreedProtocol v-model="isAgreement" customClass="agreedProtocol" :user="user"
          :items="['LOAN_DISCLOSURE', 'PERSONAL_INFO_SHARING']" />
      </div>
    </template>
  </div>
</template>

<script>
import HanderNav from "../components/HanderNav.vue";
import ProductCard from "../components/ProductCard.vue";
import MideelApply from "../components/MideelApply.vue";
import AgreedProtocol from '../components/AgreedProtocol.vue';
import { pmatch, submitProduct } from "../api";
export default {
  components: {
    HanderNav,
    ProductCard,
    MideelApply,
    AgreedProtocol,
  },
  data() {
    return {
      loading: true,
      shosP: false,
      isAgreement: true,
      isShowAgreement: false,
      submitLoading: false,
      channel_key: '',
      check_no: '',
      productList: [
        // {
        //   id: 1,
        //   title: "聚鲸融",
        //   name: "广西钱多多信息咨询有限公司",
        //   amount: "20 万",
        //   rate: 7.2,
        //   isChecked: false,
        // }
      ],
      user: {
        name: '',
        identity: '',
        mobile: '',
      }
    };
  },
  created() {
    var channel_id = this.$route.query?.channel_id
    var check_no = this.$route.query?.no
    this.channel_key = channel_id;
    this.check_no = check_no
    if (!channel_id || !check_no) {
      this.$router.push('/404');
      return;
    }
    this.user = {
      name: this.$cache.sessionGet('n'),
      identity: this.$cache.sessionGet('i'),
      mobile: this.$cache.sessionGet('m'),
    }
    this.loading = true;
    pmatch(this.channel_key, this.check_no).then(res => {
      if (res.code === 1 && res.data) {
        if (res.data.product_ids.length === 0) {
          this.$router.push(`/last?channel_id=${this.channel_key}&stage=rejected`);
          return;
        }
        var items = [];
        for (var p of res.data.product_ids) {
          items.push({
            id: p.id,
            title: p.product_name,
            name: p.product_name,
            amount: p.amount_cn,
            rate: p.interestRate_cn,
            isChecked: false,
          })
        }
        this.productList = items;
      }
      this.loading = false;
    }).catch(err => {
      this.loading = false;
    })
  },
  computed: {
    isAllSelete() {
      return this.productList.every(p => p.isChecked);
    },
    isDisabled() {
      return !this.isAgreement || !this.productList.some(n => n.isChecked === true)
    }
  },
  methods: {
    onEnd() {
      this.shosP = true;
    },
    toggleAgree() {
      this.isAgreement = !this.isAgreement;
    },
    selectProduct(product) {
    },
    onAllSeleteProduct() {
      const newStatus = !this.isAllSelete;
      this.productList.forEach(p => {
        p.isChecked = newStatus;
      })
    },
    openAgreement() {
      this.isShowAgreement = true;
    },

    submit() {
      var ids = this.productList.filter(n => n.isChecked === true).map(n => n.id);
      if (ids.length == 0) {
        this.$toast.fail('请选择产品');
        return;
      }
      this.submitLoading = true;
      submitProduct(this.channel_key, this.check_no, ids.join(',')).then(res => {
        this.submitLoading = false;
        if (res.code == 1) {
          this.$router.push(`/last?channel_id=${this.channel_key}&stage=${res.data.stage}`);
        } else {
          this.$toast.fail(res.msg || '提交失败')
        }
      }).catch(err => {
        this.submitLoading = false;
      })
    }

  },
};
</script>

<style lang="less" scoped>
.rx-app-container {
  position: relative;
  width: 100%;
  background: linear-gradient(180deg, #b9ddf2 -1.32%, #f3fbff 75.05%);
  min-height: 100vh;
  padding: 0 16px;
}


.main-content {
  position: relative;
  z-index: 10;
}

.subtitle {
  color: #254774;
  font-size: 16px;
  margin-bottom: 10px;
  padding: 0 16px;
}

.desc {
  color: #254774;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 14px;
  padding: 0 16px;
}

.desc-highlight {
  color: #ff6b00;
}

.risk-tip-container {
  margin-bottom: 8px;
  border-radius: 16px;
  border: 4px solid #b9ddf2;
  background: linear-gradient(178deg, #ffffff99 0%, #fff 80%);
  padding: 16px 0;

  .title {
    display: flex;
    color: #2e517b;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
    align-items: center;
    justify-content: center;

    i {
      display: inline-block;
      width: 16px;
      height: 16px;
      background-image: url("/images/icon-samll-warning.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin-right: 6px;
    }
  }

  .ctip {
    color: #ff6b00;
    font-weight: 700;
  }

  .tip-msg {
    color: rgba(0, 0, 0, 0.6);
    text-align: justify;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    padding: 0 16px;
    position: relative;
    z-index: 2;

    i {
      position: absolute;
      top: -18px;
      left: 50%;
      transform: translate(-50%, 0);
      width: 88px;
      height: 88px;
      background: url("/images/icon-warining.png") no-repeat center/cover;
      z-index: -2;
    }
  }
}

.select-tip {
  position: relative;
  color: #2E517B;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  padding: 0 16px;
  margin: 20px 0 24px 0;

  .select-tip-sub {
    color: rgba(46, 81, 123, 0.6);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
  }

  .selete {
    position: absolute;
    top: -4px;
    right: 10px;
    width: 32px;
    height: 32px;
    background-image: url("/images/icon-seleted.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
  }

  .selete.active {
    background-image: url("/images/icon-selete.png");
  }
}

.agreement-link {
  color: #1e7ca1;
}

.apply-btn {
  width: 100%;
  height: 50px;
  border-radius: 25px;
  background: linear-gradient(to right, #4d9bff 0%, #67d1ff 100%);
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  box-shadow: 0 4px 8px rgba(3, 92, 242, 0.12);
  border: none;
  cursor: pointer;
}
</style>
